export interface AccountRequestLike {
  businessName?: string;
  linkedBusinessId?: string | null;
  status?: string;
  createdAt?: string;
}

export function pickBusinessNameFromAccountRequests(
  requests: AccountRequestLike[],
  activeBusinessId: string | null
): string | null {
  if (!requests.length) {
    return null;
  }
  const sorted = [...requests].sort(
    (a, b) =>
      new Date(b.createdAt ?? 0).getTime() -
      new Date(a.createdAt ?? 0).getTime()
  );
  if (activeBusinessId) {
    const linked = sorted.find(
      (r) =>
        r.linkedBusinessId === activeBusinessId &&
        typeof r.businessName === "string" &&
        r.businessName.trim().length > 0
    );
    if (linked?.businessName) {
      return linked.businessName.trim();
    }
  }
  const approved = sorted.find(
    (r) =>
      r.status === "approved" &&
      typeof r.businessName === "string" &&
      r.businessName.trim().length > 0
  );
  if (approved?.businessName) {
    return approved.businessName.trim();
  }
  const anyNamed = sorted.find(
    (r) =>
      typeof r.businessName === "string" && r.businessName.trim().length > 0
  );
  return anyNamed?.businessName?.trim() ?? null;
}

/** Two-letter style initials for avatar (e.g. "80eight Test" → "8T"). */
export function initialsFromBusinessLabel(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const a = words[0][0] ?? "";
    const b = words[1][0] ?? "";
    const out = `${a}${b}`.toUpperCase();
    return out || "?";
  }
  const w = words[0] || "?";
  if (w.length >= 2) {
    return w.slice(0, 2).toUpperCase();
  }
  return w[0].toUpperCase();
}
